// deps
import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";

export const Container = styled.div`
    min-height: calc(100vh - var(--sab));
    background: #fff;
    display: flex;
    flex-direction: column;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-content: space-between;
    overflow: scroll;
    flex: 1;
`;

export const TopContentContainer = styled.div`
    padding: 0 ${(props) => props.theme.spacing.medium};
    flex: 1;
`;

export const Heading = styled(Text)`
    margin-top: ${(props) => props.theme.spacing.xLarge};
`;

export const SubHeading = styled(Text)`
    margin-top: ${(props) => props.theme.spacing.xSmall};
    margin-bottom: ${(props) => props.theme.spacing.xLarge};

    b {
        font-weight: 500;
    }
`;

export const ApplyCouponButton = styled(FullWidthButton)`
    margin-top: ${(props) => props.theme.spacing.medium};
    margin-bottom: ${(props) => props.theme.spacing.xLarge};
`;

export const Seperator = styled.div`
    width: 100%;
    padding-top: ${(props) => props.theme.spacing.small};
    background: ${(props) => props.theme.colors[props.theme.colorMode].background_Secondary};
`;

export const LocationErrorScreenContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: scroll;
    flex: 1;
`;

export const ShuttleAppName = styled.div({
    display: "none",
});
